import vSelect from 'vue-select';
export default defineNuxtPlugin(function (nuxtApp) {
  nuxtApp.vueApp.component('VSelect', vSelect);
});